// @flow
import React, { Component } from "react";
import { isEqual, get } from "lodash";
import type { RaceListItem } from "@tvg/types/Race";
import Icon from "@fdr/static-ui/Icons";
import { changes, horse, harness } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";

import {
  RaceDataList,
  RaceDataListDescription,
  RaceDataListItem,
  ChangesIcon,
  HorseIcon
} from "./styled-components";

type Props = {
  raceData: ?(RaceListItem[]),
  textColor: string,
  isIconShown?: boolean
};

export default class RaceInfoInline extends Component<Props> {
  static defaultProps = {
    raceData: [],
    textColor: buildColor("grey", "300"),
    isIconShown: false
  };

  shouldComponentUpdate(nextProps: Props) {
    return !isEqual(nextProps, this.props);
  }

  renderListItems() {
    return (
      <RaceDataListDescription>
        {this.props.raceData &&
          this.props.raceData.map((listItem: RaceListItem, index:number) => (
            <RaceDataListItem
              data-qa-label="raceInfoInline-item"
              key={`${listItem.value}-${index}`}
              changed={listItem.changed}
            >
              {listItem.changed && (
                <ChangesIcon>
                  <Icon icon={changes} size={15} />
                </ChangesIcon>
              )}
              {listItem.value}
            </RaceDataListItem>
          ))}
      </RaceDataListDescription>
    );
  }

  render() {
    const isHarness =
      get(this.props, "raceData[0]", { value: "" }).value.toLowerCase() ===
      "harness";

    return (
      <RaceDataList
        textColor={this.props.textColor}
        isIconShown={this.props.isIconShown}
      >
        {this.props.isIconShown && (
          <HorseIcon>
            <Icon
              icon={isHarness ? harness : horse}
              size={17}
              color={buildColor("grey", "800")}
            />
          </HorseIcon>
        )}
        {this.renderListItems()}
      </RaceDataList>
    );
  }
}
